export interface PredefinedQuestion {
    id: number;
    question: string;
    type: string;
}

export interface ResponseModeOption {
    // To enable, append &override_token= to /chat/{uuid}/ask/
    override_token: string;
    override_label: string;
}

export interface ChatConfiguration {
    predefined_questions: PredefinedQuestion[];
    peekaboo_enabled: boolean;
    show_product_tour: boolean;
    response_modes: ResponseModeOption[];
}

export async function fetchChatConfiguration({
    contentType,
    site,
}: {
    contentType: string;
    site?: string;
}): Promise<ChatConfiguration> {
    const params = new URLSearchParams({ content_type: contentType });

    if (site) {
        params.set('site', site);
    }

    const response = await fetch(`/api/chats/chat-configuration/?${params}`);

    if (!response.ok) {
        throw new Error(`Failed to fetch chat configuration: ${response.status}`);
    }

    return response.json();
}
